import script from "./SidebarMenuScroll.vue?vue&type=script&setup=true&lang=js"
export * from "./SidebarMenuScroll.vue?vue&type=script&setup=true&lang=js"

import "./SidebarMenuScroll.vue?vue&type=style&index=0&id=5d230f78&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/G23/web-portal/bia-webportal-prod/bia-cms-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d230f78"]])

export default __exports__